import SeoHead from "@/components/SeoHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import LocalFaqSection from "./components/LocalFaqSection";

const localServices = [
  {
    icon: "ri-home-4-line",
    title: "Pose de carrelage à Grône",
    desc: "Pose de carrelage à Grône et dans les communes voisines. Petites et grandes surfaces, joints droits, finitions qui tiennent.",
  },
  {
    icon: "ri-drop-line",
    title: "Rénovation salle de bain à Grône",
    desc: "Rénovation de salle de bain à Grône. On dépose l'ancien, on refait l'étanchéité, on pose le carrelage, on installe la robinetterie — un chantier complet, géré de A à Z.",
  },
  {
    icon: "ri-water-flash-line",
    title: "Douche italienne à Grône",
    desc: "Douche italienne à Grône. Une solution moderne et pratique, même dans les espaces compacts des habitations valaisannes. Pente calculée, joints étanches.",
  },
  {
    icon: "ri-layout-grid-line",
    title: "Faïence & mosaïque à Grône",
    desc: "Faïence et mosaïque à Grône. Des créations qui apportent du caractère à vos cuisines et salles de bain, avec des matériaux choisis pour leur solidité.",
  },
  {
    icon: "ri-sun-line",
    title: "Carrelage extérieur à Grône",
    desc: "Terrasses et allées à Grône. Carrelage technique antidérapant, résistant au gel et aux UV. Le Valais, c'est des hivers rigoureux — on pose en conséquence.",
  },
];


const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Accueil",
      "item": "https://carreaux-bat.ch/"
    },
    {
      "@type": "ListItem",
      "position": 2,
      "name": "Grône",
      "item": "https://carreaux-bat.ch/grone"
    }
  ]
};

const webPageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "Carrelage et Rénovation à Grône, Valais",
  "description": "Siège de Carreaux-Bat à Grône, Valais. Pose de carrelage, rénovation de salle de bain et douche italienne à Grône et dans tout le Valais central.",
  "url": "https://carreaux-bat.ch/grone",
  "mainEntity": {
    "@type": "LocalBusiness",
    "name": "Carreaux-Bat Valais",
    "telephone": "+41 77 511 75 52",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rue de Pramagnon 32",
      "addressLocality": "Grône",
      "addressRegion": "Valais",
      "postalCode": "3979",
      "addressCountry": "CH"
    },
    "areaServed": {
      "@type": "City",
      "name": "Grône",
      "containedInPlace": {
        "@type": "AdministrativeArea",
        "name": "Valais"
      }
    }
  }
};

export default function GronePage() {
  return (
    <div className="min-h-screen">
      <SeoHead
        title="Entreprise de Carrelage & Carreleur à Grône à Proximité | Carreaux-Bat Valais"
        description="Vous cherchez un carreleur à proximité de Grône ? Entreprise de carrelage et société de carrelage à Grône, Valais. Service de carrelage par artisan carreleur près de chez vous. Siège social Carreaux-Bat rue de Pramagnon 32. Pose de carrelage, rénovation salle de bain dans tout le Valais central. Devis gratuit."
        keywords="carreleur à proximité de Grône, entreprise de carrelage à proximité de Grône, société de carrelage à proximité de Grône, carreleur près de chez moi Grône, entreprise de carrelage près de chez vous Grône, service de carrelage à proximité, entreprise de carrelage Grône, société de carrelage Grône, service de carrelage Grône, carreleur Grône, pose de carrelage Grône, rénovation salle de bain Grône, douche italienne Grône, carrelage Sierre, artisan carreleur Valais central"
        canonical="https://carreaux-bat.ch/grone"
        ogTitle="Carrelage & Rénovation à Grône à Proximité — Siège Carreaux-Bat Valais"
        ogDescription="Vous cherchez un carreleur à proximité de Grône ? Pose de carrelage, rénovation salle de bain et douche italienne à Grône et dans tout le Valais central. Atelier rue de Pramagnon 32."
        ogImage="/images/grone-hero.jpg"
        geoPosition="46.2304;7.4381"
        geoPlacename="Grône, Valais, Suisse"
        geoRegion="CH-VS"
      schema={{
        "@context": "https://schema.org",
        "@graph": [webPageSchema, breadcrumbSchema]
      }}
      />
      <Navbar />

      {/* Hero */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <img
          src="/images/grone-hero.jpg"
          alt="Carrelage Grône Valais"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-black/70"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-6 text-center">
          <span className="inline-block mb-4 px-4 py-1.5 bg-amber-700/80 text-white text-xs font-medium tracking-widest uppercase rounded-full">
            Notre Siège Social
          </span>
          <h1 className="text-5xl font-bold text-white mb-4">Entreprise de Carrelage & Carreleur à Grône</h1>
          <p className="text-white/70 max-w-xl mx-auto text-sm leading-relaxed">
            C'est ici, à Grône, rue de Pramagnon, qu'on a posé nos outils il y a plus de 20 ans. Depuis, on rayonne dans tout le Valais central.
          </p>
          <div className="flex items-center justify-center gap-2 mt-6 text-sm text-white/50">
            <Link to="/" className="hover:text-amber-400 transition-colors">Accueil</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Grône</span>
          </div>
        </div>
      </section>

      {/* Description longue */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
            <div>
              <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Grône, Valais</span>
              <h2 className="mt-2 text-3xl font-bold text-stone-900 mb-6">Grône, au cœur de la plaine du Rhône</h2>
              <div className="space-y-4 text-sm text-stone-500 leading-relaxed">
                <p>
                  Grône est un charmant village de la commune de Sierre, situé dans la plaine du Rhône entre Sion et Sierre, à environ 500 mètres d&apos;altitude. Avec un peu plus de 1 200 habitants, ce petit bourg valaisan allie tranquillité résidentielle et proximité immédiate des grandes villes de la région.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Votre carreleur à Grône pour la pose de carrelage intérieur</h3>
                <p>
                  Le village est traversé par la Lienne, un cours d&apos;eau qui apporte une touche de verdure et de fraîcheur à ce secteur agricole. Les alentours de Grône sont marqués par des vergers, des vignobles et des cultures maraîchères qui témoignent de la richesse agricole de la plaine du Rhône. Les résidents profitent d&apos;un cadre de vie paisible tout en étant à quelques minutes de Sierre et de ses commodités.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Entreprise de carrelage à Grône — Rénovation salle de bain et douche italienne</h3>
                <p>
                  Grône bénéficie d&apos;une situation géographique idéale : à 10 minutes de Sion, à 5 minutes de Sierre, et à proximité des axes routiers principaux qui relient le Valais à Berne et à Lausanne. Cette centralité fait de Grône un lieu de vie prisé par les familles et les professionnels qui travaillent dans les centres urbains voisins mais souhaitent habiter dans un environnement calme et verdoyant.
                </p>
                <h3 className="text-lg font-bold text-stone-800 mt-6 mb-2">Service de carrelage à Grône et dans tout le Valais central</h3>
                <p>
                  C&apos;est précisément à Grône, au numéro 32 de la Rue de Pramagnon, que se situe le siège de notre entreprise de carrelage. Cette localisation centrale nous permet d&apos;intervenir rapidement dans tout le Valais central : Sion, Sierre, Monthey, Conthey, ainsi que dans les stations touristiques de Crans-Montana et d&apos;Anzère. Notre atelier et notre showroom sont à votre disposition pour découvrir nos collections de carrelage et discuter de votre projet.
                </p>
                <p>
                  Que vous habitiez dans une maison villageoise typique ou dans une villa moderne des quartiers résidentiels de Grône, on s'adapte. Carrelage, rénovation, douche italienne — on connaît le coin et on connaît le métier. Venez nous voir à l'atelier rue de Pramagnon, ou on vient chez vous.
                </p>
              </div>
            </div>
            <div>
              <div className="relative rounded-lg overflow-hidden h-96 mb-6">
                <img
                  src="/images/grone-realisation.jpg"
                  alt="Réalisation carrelage Grône"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">1 200</p>
                  <p className="text-xs text-stone-500 mt-1">Habitants à Grône</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">500 m</p>
                  <p className="text-xs text-stone-500 mt-1">Altitude</p>
                </div>
                <div className="bg-stone-50 rounded-lg p-5 border border-stone-100">
                  <p className="text-2xl font-bold text-stone-900">1h</p>
                  <p className="text-xs text-stone-500 mt-1">Délai d&apos;intervention</p>
                </div>
                <div className="bg-amber-50 rounded-lg p-5 border border-amber-100">
                  <p className="text-2xl font-bold text-amber-700">Gratuit</p>
                  <p className="text-xs text-stone-500 mt-1">Devis sur place</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services locaux */}
      <section className="py-20 bg-stone-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <span className="text-xs uppercase tracking-widest text-amber-700 font-medium">Prestations locales</span>
            <h2 className="mt-3 text-3xl font-bold text-stone-900">Nos services à Grône</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {localServices.map((service) => (
              <div key={service.title} className="bg-white rounded-lg p-6 border border-stone-100 hover:border-amber-200 transition-colors">
                <div className="w-11 h-11 flex items-center justify-center bg-amber-50 rounded-lg mb-4">
                  <i className={`${service.icon} text-amber-700 text-xl`}></i>
                </div>
                <h3 className="text-base font-semibold text-stone-900 mb-2">{service.title}</h3>
                <p className="text-sm text-stone-500 leading-relaxed">{service.desc}</p>
              </div>
            ))}
            <div className="bg-amber-700 rounded-lg p-6 flex flex-col justify-between">
              <div>
                <h3 className="text-base font-semibold text-white mb-2">Devis gratuit à Grône</h3>
                <p className="text-sm text-amber-100 leading-relaxed">Envoyez-nous un message ou passez à l'atelier rue de Pramagnon. On discute de votre projet autour d'un café, et on vous dit franchement ce qu'on peut faire.</p>
              </div>
              <Link
                to="/contact"
                className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 bg-white text-amber-700 text-sm font-medium rounded-full hover:bg-amber-50 transition-colors whitespace-nowrap"
              >
                Demander un devis
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Contact CTA */}
      <section className="py-16 bg-stone-900">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Votre projet à Grône</h2>
          <p className="text-stone-400 text-sm mb-8 max-w-xl mx-auto">
            Basés à Grône, on intervient dans un rayon de 30 kilomètres sans problème. Sion, Sierre, Monthey, Conthey, Crans-Montana — on connaît les routes et les artisans du coin. Venez nous voir à l'atelier, ou on vient chez vous.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="px-8 py-3.5 bg-amber-700 text-white font-medium rounded-full hover:bg-amber-600 transition-colors whitespace-nowrap"
            >
              Devis gratuit à Grône
            </Link>
            <a
              href="tel:+41775117552"
              className="px-8 py-3.5 border border-stone-600 text-stone-300 font-medium rounded-full hover:border-amber-600 hover:text-amber-400 transition-colors whitespace-nowrap flex items-center justify-center gap-2"
            >
              <i className="ri-phone-line"></i>
              +41 77 511 75 52
            </a>
          </div>
        </div>
      </section>

      <LocalFaqSection
        city="Grône"
        faqs={[
          {
            question: "Puis-je venir voir vos réalisations à l'atelier de Grône ?",
            answer: "Bien sûr. Notre atelier est situé au 32 rue de Pramagnon à Grône. On y expose des échantillons de carrelage, des finitions de joints, et on peut vous montrer des photos de nos chantiers récents. Passez quand vous voulez, on est là du lundi au samedi matin."
          },
          {
            question: "Quel est votre rayon d'intervention depuis Grône ?",
            answer: "On intervient dans un rayon d'environ 50 kilomètres autour de Grône, ce qui couvre tout le Valais central et une partie du Haut-Valais. Sion, Sierre, Martigny, Monthey, Conthey, Crans-Montana, Verbier, Nendaz — on se déplace partout."
          },
          {
            question: "Faites-vous les devis gratuits à domicile dans le Valais central ?",
            answer: "Oui, tous nos devis sont gratuits et sans engagement. On vient chez vous, on mesure, on discute de vos envies et de votre budget, et on vous envoie un devis détaillé sous 48h. Pas de surprise, pas de frais cachés."
          },
          {
            question: "Travaillez-vous dans les maisons villageoises de Grône ?",
            answer: "Grône est notre quartier, on y travaille régulièrement. Les maisons villageoises ont leur charme et leurs contraintes. On sait moderniser une salle de bain ou poser du carrelage tout en respectant l'esprit du lieu."
          },
          {
            question: "Combien de temps dure une rénovation de salle de bain à Grône ?",
            answer: "Comptez entre 2 et 4 semaines pour une rénovation complète, de la démolition à la pose finale. On coordonne tous les corps de métier pour que vous n'ayez pas à gérer plusieurs artisans. On vous donne un planning clair dès le départ."
          },
          {
            question: "Proposez-vous du carrelage imitation bois pour les intérieurs valaisans ?",
            answer: "Oui, le carrelage imitation bois est très demandé en Valais. Il allie l'esthétique chaleureuse du bois à la résistance du grès cérame. Parfait pour les intérieurs montagnards, il ne se déforme pas avec l'humidité et il est très facile d'entretien."
          }
        ]}
      />

      <Footer />
    </div>
  );
}
